import React from "react";
import ReactDOM from "react-dom/client";
import App, { SessionStatus } from "./App";
import { bootstrapSession } from "./sessionApi";
import "./h5.css";
import "./prototype.css";

const root = ReactDOM.createRoot(document.getElementById("root")!);

function render(node: React.ReactNode) {
  root.render(<React.StrictMode>{node}</React.StrictMode>);
}

render(<SessionStatus />);
bootstrapSession()
  .then(() => render(<App />))
  .catch((error) => render(<SessionStatus error={error instanceof Error ? error.message : "登录暂时无法完成"} />));
